import React from 'react';
import { LayoutDashboardLeftMenuLogoStyle as S } from './LayoutDashboardLeftMenuLogo.style';
import { Box } from 'components/layouts/primitives/Box/Box';
import { Icon } from 'components/Icon/Icon';
import { Link } from 'react-router';
import { useIsReactPage } from 'hooks/useIsReactPage';

export const LayoutDashboardLeftMenuLogo: React.FC = () => {
  const isReactPage = useIsReactPage();
  const logo = (
    <>
      <Box className="left-menu-open-element">
        <S.YabbleLogo testId='logo-yabble' />
      </Box>
      <Box padding="paddingSM" className="left-menu-closed-element">
        <Icon icon="yabbleLogoSolid" size={24} color="neutral900" className="block" />
      </Box>
    </>
  );

  return <Box fit="content">{isReactPage ? <Link to="/">{logo}</Link> : <a href="/">{logo}</a>}</Box>;
};
